import {inject, Injectable, signal} from '@angular/core';
import {environment} from '@/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {Notification} from '@/app/core/models/notification';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	private readonly SERVICE_URI = `${environment.backendUrl}/notifications`;

	private readonly http: HttpClient = inject(HttpClient);

	/**
	 * État partagé — `peps-notification-center` est monté deux fois dans le
	 * navbar (desktop + mobile, une seule visible selon le breakpoint) ; sans
	 * ce partage, chaque instance déclenchait son propre appel réseau.
	 */
	readonly notifications = signal<Notification[]>([]);
	private loaded = false;
	private inFlight = false;

	/** Charge les notifications une seule fois, partagé entre toutes les instances du composant. */
	fetchNotifications(force = false): void {
		if ((this.loaded || this.inFlight) && !force) return;
		this.inFlight = true;
		this.http.get<Notification[]>(this.SERVICE_URI).subscribe({
			next: (notifications) => {
				this.notifications.set(notifications);
				this.loaded = true;
				this.inFlight = false;
			},
			error: () => {
				this.inFlight = false;
			},
		});
	}

	markAllAsRead(): Observable<void> {
		return this.http.put<void>(`${this.SERVICE_URI}/mark-all-read`, {}).pipe(
			tap(() => this.notifications.update(list => list.map(n => ({...n, read: true}))))
		);
	}

	/** Marque une notification précise comme lue (clic sur « Voir »). */
	markAsRead(id: string): Observable<void> {
		return this.http.put<void>(`${this.SERVICE_URI}/${id}/read`, {}).pipe(
			tap(() => this.notifications.update(list => list.map(n => n.id === id ? {...n, read: true} : n)))
		);
	}

}
